/* eslint-disable import/no-anonymous-default-export */
export default (stats = [], action) => {
  switch (action.type) {
    case "YEAR_STATS":
      return action.payload;

    default:
      return stats;
  }
};
